import { Button, Flex, Text } from "@engaging-tech/components"
import { Redirect } from "@engaging-tech/routing"
import { Auth } from "aws-amplify"
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import SendVerifyEmailImage from "../assets/images/SendVerifyEmailImage"
import { requestConfirmation } from "../features/yourProfile/store/yourProfile.actions"
import { getIsConfirmed, getUserEmail } from "../features/yourProfile/store/yourProfile.selectors"
import BaseLayout from "../layouts/BaseLayout"

const NotVerified = () => {
  const dispatch = useDispatch()
  const userEmail = useSelector(getUserEmail)
  const isConfirmed = useSelector(getIsConfirmed)
  const onClick = () => dispatch(requestConfirmation())

  if (isConfirmed) return <Redirect to="/" />

  return (
    <BaseLayout>
      <Flex mt={68} mb={140} width={1 / 1} justifyContent="center">
        <Flex flexDirection="column" alignItems="center" width="fit-content" height="fit-content">
          <Text
            mb={12}
            fontSize="40px"
            fontWeight="700"
            lineHeight="52px"
            letterSpacing="1px"
            textAlign="center"
            color="primary.0"
          >
            You must be verified to see this page.
          </Text>
          <Text
            mb={36}
            fontSize="20px"
            fontWeight="400"
            lineHeight="32px"
            letterSpacing="0px"
            textAlign="center"
            color="primary.0"
          >
            To keep your account secure, please verify your email address. We will send a secure link to{" "}
            {userEmail}.
          </Text>
          <SendVerifyEmailImage />
          <Flex mt={36} alignItems="center">
            <Button px={24} py={12} borderRadius="50px" bg="secondary.0" onClick={onClick}>
              SEND VERIFiCATION EMAIL
            </Button>
          </Flex>
        </Flex>
      </Flex>
    </BaseLayout>
  )
}

export default NotVerified
